import LocaleKeys from '../../../locales/keys';
import { i18n } from 'invision-core';
export default function ChargeDetailsPopout(uiTetherProvider) {
  return {
    restrict: 'AE',
    scope: {
      popupAttachment: '@',
      popupPosition: '@',
      chargeDetails: '<'
    },
    link: function link(scope, element) {
      scope.chargeDetails = scope.chargeDetails || {};
      scope.localeKeys = LocaleKeys;
      uiTetherProvider({
        target: element,
        template: require('./charge.details.popout.html'),
        scope: scope,
        position: scope.popupPosition ? scope.popupPosition : 'bottom center',
        openOn: 'click',
        tetherOptions: {
          attachment: scope.popupAttachment ? scope.popupAttachment : 'top center'
        }
      });
    }
  };
}